export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20flowing%20red%20and%20deep%20amber%20light%20streaks%20on%20pure%20charcoal%20black%20background%2C%20minimalist%20film%20strip%20elements%2C%20premium%20streaming%20platform%20atmosphere%2C%20elegant%20shadows%2C%20sophisticated%20entertainment%20brand%20visual%2C%20subtle%20glow%20effects%2C%208k%20quality&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="苹果视频 - 免费高清影视平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 pt-20 md:pt-24">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-sm font-medium text-primary-300 whitespace-nowrap">
                每日更新 · 全网热门资源聚合
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight tracking-tight">
              苹果视频
              <br className="sm:hidden" />
              <span className="text-primary-400">· 免费高清影视平台</span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-medium">
              畅享流畅不缓冲的观影体验
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              苹果视频汇聚香蕉视频、红桃视频、91视频、蜜桃视频等全网热门资源，覆盖电影、电视剧、
              动漫、综艺全品类内容。无需注册、无需付费，打开即看。多线路智能调度，保障高清流畅不缓冲，
              每日同步最新热播资源，做您最贴心的免费观影伴侣。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-500/15 flex items-center justify-center">
                  <i className="ri-film-line text-primary-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-800 font-mono">5.2万+</div>
                  <div className="text-xs text-foreground-500">影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-accent-500/15 flex items-center justify-center">
                  <i className="ri-user-smile-line text-accent-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-800 font-mono">860万+</div>
                  <div className="text-xs text-foreground-500">活跃用户</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-secondary-500/15 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-400 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-800 font-mono">24h</div>
                  <div className="text-xs text-foreground-500">每日更新</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-foreground-950 font-semibold rounded-lg transition-all duration-200 whitespace-nowrap text-center text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-400/60 hover:bg-background-400 border border-background-500/50 text-foreground-800 font-medium rounded-lg transition-all duration-200 whitespace-nowrap text-center text-sm"
              >
                <i className="ri-download-line mr-2"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20streaming%20platform%20interface%20mockup%20with%20movie%20poster%20thumbnails%2C%20warm%20red%20and%20amber%20accent%20highlights%2C%20modern%20video%20player%20design%2C%20deep%20charcoal%20background%2C%20premium%20entertainment%20aesthetic%2C%20clean%20layout%20with%20glowing%20elements&width=800&height=600&seq=hero-visual-main&orientation=landscape"
                alt="苹果视频播放界面预览"
                className="relative w-full rounded-xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}